var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportChatRoomDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icReportChatRoomDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-4",
    transform: "translate(-1157.000000, -830.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(893.000000, 786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icReportChatRoomDesktop",
    transform: "translate(264.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.47747628,0 0,4.47747628 0,10 C0,15.523153 4.47747628,20 10,20 C15.523153,20 20,15.5237822 20,10 C20,4.47747628 15.5230831,0 10,0 Z M10,18.1249694 C5.51252561,18.1249694 1.87503059,14.4874744 1.87503059,10 C1.87503059,5.51252561 5.51252561,1.87503059 10,1.87503059 C14.4874744,1.87503059 18.1249694,5.51252561 18.1249694,10 C18.1249694,14.4874744 14.4874744,18.1249694 10,18.1249694 Z M10.0006293,4.38560552 C9.28440085,4.38560552 8.7424752,4.7593811 8.7424752,5.36311326 L8.7424752,10.9005992 C8.7424752,11.5049606 9.28433093,11.8774777 10.0006293,11.8774777 C10.6993784,11.8774777 11.2587833,11.4893691 11.2587833,10.9005992 L11.2587833,5.36311326 C11.2587134,4.77371405 10.6993784,4.38560552 10.0006293,4.38560552 Z M10.0006293,13.1250044 C9.31250743,13.1250044 8.75247331,13.6850385 8.75247331,14.3737196 C8.75247331,15.0612122 9.31250743,15.6212463 10.0006293,15.6212463 C10.6887511,15.6212463 11.2481559,15.0612122 11.2481559,14.3737196 C11.248086,13.6849686 10.6887511,13.1250044 10.0006293,13.1250044 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportChatRoomDesktop);
export default __webpack_public_path__ + "static/media/icReportChatRoomDesktop.73c00b5006caa9571efdad54a785c3c8.svg";
export { ForwardRef as ReactComponent };